<template>
  <b-overlay :show="busy" rounded="sm">
    <!-- {{ search }}<br /><br />
        {{ item }} -->
    <b-card class="standardpage reports invoices border-none">
      <!-- <b-card-header class="py-1 mb-2">
            <i :class="options.icon" class="text-primary mr-1"></i>
            {{ item.slac }}
            <span class="text-warning"
              >&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span
            >
          </b-card-header> -->
      <div class="availtable datatable text-left">
        <b-card-body class="py-0">
          <b-tabs class="gridtabs">
            <b-tab :active="true">
              <template #title>
                <div class="badgecontainer pr-5">
                  <i :class="carbonemissions.icon" class="text-primary mr-1"></i>
                  <span class="text-center badgenormal badge-secondary badge-pill">
                    {{ item.traveller }}
                  </span>
                  <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span>
                </div>
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Event" label-size="sm">
                      <treeselect placeholder="Select event..." searchPromptText="Type at least 4 chars..."
                        v-model="item.eventcode" :clearable="true" :async="true" :load-options="treeselect_loadEvent"
                        :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true"
                        :matchKeys="['id']" search-nested>
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" :label="$helpers.requiredlabel(
    requirement_carbonemissions,
    'Client SL A/C'
  )
    " :class="$helpers
    .requiredlabel(
      requirement_carbonemissions,
      'Client SL A/C'
    )
    .slice(0, 1) == '*'
    ? 'text-danger'
    : ''
    " label-size="sm">
                      <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..."
                        v-model="item.slac" :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                        :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true"
                        :matchKeys="['id']" search-nested :disabled="false">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Start Date" label-for="startdate" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.startdate" button-only label-help="" locale="en-GB"
                            hide-header :disabled="readonly"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.startdate" type="text"
                          placeholder="YYYY-MM-DD hh:mm" autocomplete="off" :disabled="readonly"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                            @click="item.startdate = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="End Date" label-for="enddate" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.enddate" button-only label-help="" locale="en-GB"
                            hide-header :disabled="readonly"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.enddate" type="text"
                          placeholder="YYYY-MM-DD hh:mm" autocomplete="off" :disabled="readonly"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                            @click="item.enddate = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Traveller" label-for="traveller" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.traveller" placeholder="Enter traveller"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.traveller = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col v-if="quantity" cols="12" sm="6" md="4" xl="3">
                    <b-form-group :label="quantity" label-for="quantity" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.quantity" :placeholder="'Enter ' + quantity"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.quantity = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Start City" label-for="startcity" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.startcity" placeholder="Enter start city"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.startcity = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col v-if="endcity" cols="12" sm="6" md="4" xl="3">
                    <b-form-group :label="endcity" label-for="endcity" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.endcity" :placeholder="'Enter ' + endcity"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.endcity = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col v-if="ticketno" cols="12" sm="6" md="4" xl="3">
                    <b-form-group :label="ticketno" label-for="ticketno" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.ticketno" :placeholder="'Enter ' + ticketno"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.ticketno = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col v-if="category" cols="12" sm="6" md="4" xl="3">
                    <b-form-group :label="category" label-for="category" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.category" :placeholder="'Enter ' + category"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.category = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col v-if="flightno" cols="12" sm="6" md="4" xl="3">
                    <b-form-group :label="flightno" label-for="flightno" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.flightno" :placeholder="'Enter ' + flightno"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.flightno = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col v-if="confirmationno" cols="12" sm="6" md="4" xl="3">
                    <b-form-group :label="confirmationno" label-for="confirmationno" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.confirmationno" :placeholder="'Enter ' + confirmationno"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.confirmationno = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col v-if="vehicle" cols="12" sm="6" md="4" xl="3">
                    <b-form-group :label="vehicle" label-for="vehicle" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.vehicle" :placeholder="'Enter ' + vehicle"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.vehicle = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col v-if="supplier" cols="12" sm="6" md="4" xl="3">
                    <b-form-group :label="supplier" label-for="supplier" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.supplier" :placeholder="'Enter ' + supplier"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.supplier = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col v-if="duration" cols="12" sm="6" md="4" xl="3">
                    <b-form-group :label="duration" label-for="duration" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.duration" :placeholder="'Enter ' + duration"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.duration = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col v-if="distance" cols="12" sm="6" md="4" xl="3">
                    <b-form-group :label="distance" label-for="distance" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.distance" :placeholder="'Enter ' + distance"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.distance = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col v-if="data" cols="12">
                    <b-form-group :label="data" label-for="data" label-cols="12">
                      <b-input-group>
                        <b-form-textarea v-model="item.data" :placeholder="'Enter ' + data" size="sm" rows="5"
                          class="smalltextarea"></b-form-textarea>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab>
            <b-tab v-if="idselected">
              <template #title>
                <i class="fa fa-history text-primary mr-1"></i> Audit
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created At" label-for="created_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.created_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.created_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created By" label-for="created_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.created_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.updated_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.updated_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.updated_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab></b-tabs>
        </b-card-body>
        <b-card-footer class="nopadding mt-2">
          <b-row no-gutters>
            <b-col cols="auto" class="text-left mr-3">
              <b-button squared size="sm" variant="primary" @click="saveit">
                <i class="fa fa-check"></i>
                Save It
              </b-button>
            </b-col>
            <b-col class="text-left my-auto">
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin text-primary"></i>
              </div>
              <div v-else>
                <span v-html="message"></span>
              </div>
            </b-col>
            <b-col class="text-right" cols="8">
              <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
                <i class="fa fa-chevron-left pr-1"></i>
                Back
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>

      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import moment from "moment";

export default {
  name: "CarbonEmissionsEdit",
  props: ["variables"],
  data() {
    return {
      busy: false,
      requirement_carbonemissions: {
        slac: "Client SL A/C",
      },
      readonly: false,
      item: {
        id: null,
        type: null,
        eventcode: null,
        slac: null,
        traveller: null,
        startdate: null,
        startcity: null,
        duration: null,
        quantity: null,
        distance: null,
        category: null,
        ticketno: null,
        flightno: null,
        confirmationno: null,
        vehicle: null,
        supplier: null,
        enddate: null,
        endcity: null,
        data: null
      },
      carbonemissions: {
        title: "Client Emissions",
        icon: "fa fa-globe",
        fields_0: [
          {
            key: "eventcode",
            label: "Event Code",
            type: "treeselect",
            placeholder: "Event",
            class: "text-right w-120px",
            clearable: "true",
          },
          {
            key: "slac",
            label: "SL A/C",
            type: "treeselect",
            placeholder: "SL A/C",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "startdate",
            label: "Start Date",
            type: "daterangepicker",
            placeholder: "Daterange (from-to)",
            class: "text-right w-120px",
            singleDatePicker: "range",
            opens: "left",
            clearable: "true",
          },
          {
            key: "traveller",
            label: "Traveller",
            class: "text-left",
            type: "text",
            placeholder: "Traveller",
            class: "text-right w-120px",
            clearable: "true",
          },
          {
            key: "quantity",
            label: "Qty",
            type: "text",
            placeholder: "Qty",
            class: "text-right w-40px",
            clearable: "true",
          },
          {
            key: "startcity",
            label: "Start City",
            type: "treeselect",
            placeholder: "Start City",
            class: "text-right w-80px",
            clearable: "true",
          },

          {
            key: "endcity",
            label: "End City",
            type: "treeselect",
            placeholder: "End City",
            class: "text-right w-80px",
            clearable: "true",
          },
          {
            key: "category",
            label: "Class",
            type: "text",
            placeholder: "Class",
            class: "text-right w-90px",
            clearable: "true",
            datalist: ["ECONOMY", "PREMIUM", "BUSINESS", "FIRST"],
          },
          {
            key: "flightno",
            label: "FlightNo",
            type: "text",
            placeholder: "FlightNo",
            class: "text-right w-90px",
            clearable: "true",
          },
          {
            key: "confirmationno",
            label: "Locator",
            type: "text",
            placeholder: "Locator",
            class: "text-right w-90px",
            clearable: "true",
          },
          {
            key: "vehicle",
            label: "Aircraft",
            type: "text",
            placeholder: "Aircraft",
            class: "text-right w-90px",
            clearable: "true",
          },
          {
            key: "ticketno",
            label: "TicketNo",
            type: "text",
            placeholder: "TicketNo",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "supplier",
            label: "Supplier",
            type: "text",
            placeholder: "Supplier",
            class: "text-right w-70px",
            clearable: "true",
          },
          {
            key: "data",
            label: "Data",
            type: "text",
            placeholder: "Data",
            class: "text-right w-80px",
            clearable: "true",
          },
        ],
        fields_1: [
          {
            key: "eventcode",
            label: "Event Code",
            type: "treeselect",
            placeholder: "Event",
            class: "text-right w-80px",
            clearable: "true",
          },
          {
            key: "slac",
            label: "SL A/C",
            type: "treeselect",
            placeholder: "SL A/C",
            class: "text-right w-80px",
            clearable: "true",
          },
          {
            key: "startdate",
            label: "Start Date",
            type: "daterangepicker",
            placeholder: "Daterange (from-to)",
            class: "text-right w-100px",
            singleDatePicker: "range",
            opens: "left",
            clearable: "true",
          },
          {
            key: "traveller",
            label: "Traveller",
            class: "text-left",
            type: "text",
            placeholder: "Traveller",
            class: "text-right w-120px",
            clearable: "true",
          },
          {
            key: "quantity",
            label: "Qty",
            type: "text",
            placeholder: "Qty",
            class: "text-right w-40px",
            clearable: "true",
          },
          {
            key: "startcity",
            label: "Start City",
            type: "treeselect",
            placeholder: "City",
            class: "text-right w-60px",
            clearable: "true",
          },
          {
            key: "category",
            label: "Room Type",
            class: "text-left",
            type: "text",
            placeholder: "Type",
            class: "text-right w-50px",
            clearable: "true",
            datalist: ["SINGLE", "DOUBLE", "TWIN"],
          },
          {
            key: "vehicle",
            label: "Hotel",
            class: "text-left",
            type: "text",
            placeholder: "Hotel",
            class: "text-right w-100px",
            clearable: "true",
          },

          {
            key: "quantity",
            label: "Rooms",
            type: "text",
            placeholder: "Rooms",
            class: "text-right w-40px",
            clearable: "true",
          },
          {
            key: "duration",
            label: "Nights",
            sortable: true,
            type: "text",
            placeholder: "Nights",
            class: "text-right w-40px",
            clearable: "true",
          },
          {
            key: "data",
            label: "Data",
            type: "text",
            placeholder: "Data",
            class: "text-right w-80px",
            clearable: "true",
          },
        ],
        fields_2: [
          {
            key: "eventcode",
            label: "Event Code",
            type: "treeselect",
            placeholder: "Event",
            class: "text-right w-120px",
            clearable: "true",
          },
          {
            key: "slac",
            label: "SL A/C",
            type: "treeselect",
            placeholder: "SL A/C",
            class: "text-right ",
            clearable: "true",
          },
          {
            key: "startdate",
            label: "Start Date",
            type: "daterangepicker",
            placeholder: "Daterange (from-to)",
            class: "text-right w-170px",
            singleDatePicker: "range",
            opens: "left",
            clearable: "true",
          },
          {
            key: "traveller",
            label: "Traveller",
            type: "text",
            placeholder: "Traveller",
            class: "text-right w-25pct",
            clearable: "true",
          },
          {
            key: "quantity",
            label: "Qty",
            type: "text",
            placeholder: "Qty",
            class: "text-right w-40px",
            clearable: "true",
          },
          {
            key: "startcity",
            label: "Start City",
            type: "treeselect",
            placeholder: "City",
            class: "text-right w-80px",
            clearable: "true",
          },
          {
            key: "category",
            label: "Car Type",
            type: "text",
            placeholder: "Car Type",
            class: "text-right w-140px",
            clearable: "true",
            datalist: [
              "MINI",
              "SUPERMINI",
              "LOWER_MEDIUM",
              "UPPER_MEDIUM",
              "EXECUTIVE",
              "LUXURY",
              "SPORTS",
              "DUAL_PURPOSE_4X4",
              "MPV",
              "SMALL_CAR",
              "MEDIUM_CAR",
              "LARGE_CAR",
              "AVERAGE_CAR",
              "SMALL_MOTORBIKE",
              "MEDIUM_MOTORBIKE",
              "LARGE_MOTORBIKE",
              "AVERAGE_MOTORBIKE",
            ],
          },
          {
            key: "supplier",
            label: "Supplier",
            class: "text-left",
            type: "text",
            placeholder: "Supplier",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "distance",
            label: "Distance KM",
            type: "text",
            placeholder: "Quantity",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "data",
            label: "Data",
            type: "text",
            placeholder: "Data",
            class: "text-right w-80px",
            clearable: "true",
          },
        ],
        // fields_3: [
        //   {
        //     key: "eventcode",
        //     label: "Event Code",
        //     type: "treeselect",
        //     placeholder: "Event",
        //     class: "text-right w-90px",
        //     clearable: "true",
        //   },
        //   {
        //     key: "slac",
        //     label: "SL A/C",
        //     type: "treeselect",
        //     placeholder: "SL A/C",
        //     class: "text-right w-100px",
        //     clearable: "true",
        //   },
        //   {
        //     key: "startdate",
        //     label: "Start Date",
        //     type: "daterangepicker",
        //     placeholder: "Daterange (from-to)",
        //     class: "text-right w-100px",
        //     singleDatePicker: "range",
        //     opens: "left",
        //     clearable: "true",
        //   },
        //   {
        //     key: "traveller",
        //     label: "Traveller",
        //     type: "text",
        //     placeholder: "Traveller",
        //     class: "text-right w-15pct",
        //     clearable: "true",
        //   },
        //   {
        //     key: "startcity",
        //     label: "Start City",
        //     type: "treeselect",
        //     placeholder: "City",
        //     class: "text-right w-50px",
        //     clearable: "true",
        //   },

        //   {
        //     key: "endcity",
        //     label: "End City",
        //     type: "text",
        //     placeholder: "City",
        //     class: "text-right w-50px",
        //     clearable: "true",
        //   },
        //   {
        //     key: "category",
        //     label: "Rail Type",
        //     type: "text",
        //     placeholder: "Rail Type",
        //     class: "text-right w-60px",
        //     clearable: "true",
        //     datalist: [
        //       "NATIONAL_RAIL",
        //       "INTERNATIONAL_RAIL",
        //       "LIGHT_RAIL",
        //       "TRAM",
        //       "SUBWAY",
        //       "LONDON_UNDERGROUND",
        //     ],
        //   },
        //   {
        //     key: "supplier",
        //     label: "Supplier",
        //     type: "text",
        //     placeholder: "Supplier",
        //     class: "text-right w-80px",
        //     clearable: "true",
        //   },

        //   {
        //     key: "distance",
        //     label: "Journey KM",
        //     type: "text",
        //     placeholder: "Journey KM",
        //     class: "text-right w-50px",
        //     clearable: "true",
        //   },
        //   {
        //     key: "data",
        //     label: "Data",
        //     type: "text",
        //     placeholder: "Data",
        //     class: "text-right w-80px",
        //     clearable: "true",
        //   },
        // ],
        fields_3: [
          {
            key: "eventcode",
            label: "Event Code",
            type: "treeselect",
            placeholder: "Event",
            class: "text-right w-120px",
            clearable: "true",
          },
          {
            key: "slac",
            label: "SL A/C",
            type: "treeselect",
            placeholder: "SL A/C",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "startdate",
            label: "Start Date",
            type: "daterangepicker",
            placeholder: "Daterange (from-to)",
            class: "text-right w-100px",
            singleDatePicker: "range",
            opens: "left",
            clearable: "true",
          },
          {
            key: "traveller",
            label: "Traveller",
            type: "text",
            placeholder: "Traveller",
            class: "text-right w-120px",
            clearable: "true",
          },
          {
            key: "quantity",
            label: "Qty",
            type: "text",
            placeholder: "Qty",
            class: "text-right w-40px",
            clearable: "true",
          },
          {
            key: "startcity",
            label: "Start City",
            type: "treeselect",
            placeholder: "City",
            class: "text-right w-80px",
            clearable: "true",
          },

          {
            key: "vehicle",
            label: "Equipment",
            type: "text",
            placeholder: "Equipment",
            class: "text-right w-80px",
            clearable: "true",
            datalist: [
              "MINI",
              "SUPERMINI",
              "LOWER_MEDIUM",
              "UPPER_MEDIUM",
              "EXECUTIVE",
              "LUXURY",
              "SPORTS",
              "DUAL_PURPOSE_4X4",
              "MPV",
              "SMALL_CAR",
              "MEDIUM_CAR",
              "LARGE_CAR",
              "AVERAGE_CAR",
              "SMALL_MOTORBIKE",
              "MEDIUM_MOTORBIKE",
              "LARGE_MOTORBIKE",
              "AVERAGE_MOTORBIKE",
            ],
          },
          // {
          //   key: "supplier",
          //   label: "Supplier",
          //   type: "text",
          //   placeholder: "Supplier",
          //   class: "text-right w-80px",
          //   clearable: "true",
          // },
          {
            key: "distance",
            label: "Distance KM",
            type: "text",
            placeholder: "Distance",
            class: "text-right w-70px",
            clearable: "true",
          },
          {
            key: "data",
            label: "Data",
            type: "text",
            placeholder: "Data",
            class: "text-right w-80px",
            clearable: "true",
          },
        ],
        fields_4: [
          {
            key: "eventcode",
            label: "Event Code",
            type: "treeselect",
            placeholder: "Event",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "slac",
            label: "SL A/C",
            type: "treeselect",
            placeholder: "SL A/C",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "startdate",
            label: "Start Date",
            type: "daterangepicker",
            placeholder: "Daterange (from-to)",
            class: "text-right w-80px",
            singleDatePicker: "range",
            opens: "left",
            clearable: "true",
          },
          {
            key: "traveller",
            label: "Traveller",
            type: "text",
            placeholder: "Traveller",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "quantity",
            label: "Qty",
            type: "text",
            placeholder: "Qty",
            class: "text-right w-40px",
            clearable: "true",
          },
          {
            key: "startcity",
            label: "Start City",
            type: "treeselect",
            placeholder: "City",
            class: "text-right w-60px",
            clearable: "true",
          },

          {
            key: "category",
            label: "Coach Type",
            type: "text",
            placeholder: "Coach Type",
            class: "text-right w-80px",
            clearable: "true",
          },
          {
            key: "supplier",
            label: "Supplier",
            type: "text",
            placeholder: "Supplier",
            class: "text-right w-80px",
            clearable: "true",
          },
          {
            key: "distance",
            label: "Distance KM",
            type: "text",
            placeholder: "Distance",
            class: "text-right w-80px",
            clearable: "true",
          },
          {
            key: "data",
            label: "Data",
            type: "text",
            placeholder: "Data",
            class: "text-right w-80px",
            clearable: "true",
          },
        ],
        fields_5: [
          {
            key: "eventcode",
            label: "Event Code",
            type: "treeselect",
            placeholder: "Event",
            class: "text-right w-100px",
            clearable: "true",
          },
          {
            key: "slac",
            label: "SL A/C",
            type: "treeselect",
            placeholder: "SL A/C",
            class: "text-right w-100px",
            clearable: "true",
          },

          {
            key: "startdate",
            label: "Start Date",
            type: "daterangepicker",
            placeholder: "Daterange (from-to)",
            class: "text-right w-100px",
            singleDatePicker: "range",
            opens: "left",
            clearable: "true",
          },
          {
            key: "traveller",
            label: "Traveller",
            type: "text",
            placeholder: "Traveller",
            class: "text-right w-20pct",
            clearable: "true",
          },
          {
            key: "startcity",
            label: "Start City",
            type: "treeselect",
            placeholder: "City",
            class: "text-right w-60px",
            clearable: "true",
          },

          {
            key: "category",
            label: "Ferry Type",
            type: "text",
            placeholder: "Category",
            class: "text-right w-80px",
            clearable: "true",
            datalist: ["car", "coach", "foot", "average"],
          },
          {
            key: "supplier",
            label: "Supplier",
            type: "text",
            placeholder: "Supplier",
            class: "text-right w-80px",
            clearable: "true",
          },
          {
            key: "distance",
            label: "Distance KM",
            type: "text",
            placeholder: "Distance",
            class: "text-right w-80px",
            clearable: "true",
          },
          {
            key: "data",
            label: "Data",
            type: "text",
            placeholder: "Data",
            class: "text-right w-80px",
            clearable: "true",
          },
        ],
      },
    };
  },
  watch: {
    selection() {
      this.load();
    },
  },
  computed: {
    vehicle() {
      let label = "";
      if (this.item.type) {
        let fields = this.carbonemissions["fields_" + this.item.type];
        let found = fields.find((o) => o.key == "vehicle");
        if (found) {
          label = found.label;
        }
      }
      return label;
    },
    quantity() {
      let label = "";
      if (this.item.type) {
        let fields = this.carbonemissions["fields_" + this.item.type];
        let found = fields.find((o) => o.key == "quantity");
        if (found) {
          label = found.label;
        }
      }
      return label;
    },
    supplier() {
      let label = "";
      if (this.item.type) {
        let fields = this.carbonemissions["fields_" + this.item.type];
        let found = fields.find((o) => o.key == "supplier");
        if (found) {
          label = found.label;
        }
      }
      return label;
    },
    duration() {
      let label = "";
      if (this.item.type) {
        let fields = this.carbonemissions["fields_" + this.item.type];
        let found = fields.find((o) => o.key == "duration");
        if (found) {
          label = found.label;
        }
      }
      return label;
    },
    endcity() {
      let label = "";
      if (this.item.type) {
        let fields = this.carbonemissions["fields_" + this.item.type];
        let found = fields.find((o) => o.key == "endcity");
        if (found) {
          label = found.label;
        }
      }
      return label;
    },
    distance() {
      let label = "";
      if (this.item.type) {
        let fields = this.carbonemissions["fields_" + this.item.type];
        let found = fields.find((o) => o.key == "distance");
        if (found) {
          label = found.label;
        }
      }
      return label;
    },
    category() {
      let label = "";
      if (this.item.type) {
        let fields = this.carbonemissions["fields_" + this.item.type];
        let found = fields.find((o) => o.key == "category");
        if (found) {
          label = found.label;
        }
      }
      return label;
    },
    flightno() {
      let label = "";
      if (this.item.type) {
        let fields = this.carbonemissions["fields_" + this.item.type];
        let found = fields.find((o) => o.key == "flightno");
        if (found) {
          label = found.label;
        }
      }
      return label;
    },
    confirmationno() {
      let label = "";
      if (this.item.type) {
        let fields = this.carbonemissions["fields_" + this.item.type];
        let found = fields.find((o) => o.key == "confirmationno");
        if (found) {
          label = found.label;
        }
      }
      return label;
    },
    ticketno() {
      let label = "";
      if (this.item.type) {
        let fields = this.carbonemissions["fields_" + this.item.type];
        let found = fields.find((o) => o.key == "ticketno");
        if (found) {
          label = found.label;
        }
      }
      return label;
    },
    data() {
      let label = "";
      if (this.item.type) {
        let fields = this.carbonemissions["fields_" + this.item.type];
        let found = fields.find((o) => o.key == "data");
        if (found) {
          label = found.label;
        }
      }
      return label;
    },
  },
  methods: {
    async load() {
      let variables = {
        id: this.selection[0].id,
        // dateformat: "YYYY-MM-DD",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query carbonemissions($id: String) {
              carbonemissions(id: $id) {
                id
                type
                eventcode
                slac
                traveller
                start_at
                startcity
                duration
                quantity
                distance
                category
                flightno
                confirmationno
                vehicle
                ticketno
                supplier
                end_at
                endcity
                data
                updated_at
                updated_by
                created_at
                created_by
                rows
              }
            }
          `,
          variables,
        });

        this.item = response.data.carbonemissions[0];
        if (this.item.startdate) {
          this.item.startdate = this.$helpers.datetimefield(
            this.item.startdate
          );
        }
        if (this.item.enddate) {
          this.item.enddate = this.$helpers.datetimefield(this.item.enddate);
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async saveit() {
      let requirement = { ...this.requirement_carbonemissions };

      console.log(requirement);

      let requirements = "";
      for (var prop in requirement) {
        if (this.item[prop] == null) {
          requirements += requirement[prop] + ", ";
          // break;
        }
      }
      if (requirements.length > 0) {
        this.message =
          "<span class='text-danger'>" +
          requirements.slice(0, -1) +
          " required field(s). </span>";
        return;
      }
      this.busy = true;

      if (this.selection.length == 0) { this.item.type = this.variables.type }

      let variables = { rows: [this.cleanit(this.item)] };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation carbonemissions_save(
              $rows: [Carbonemission_input]
              $dateformat: String
            ) {
              carbonemissions_save(rows: $rows, dateformat: $dateformat) {
                id
              }
            }
          `,
          variables,
        });
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },

    required(e) {

      this.requirement = {
        slac: "Client SL A/C",
      };
    },
  },
};
</script>

<style></style>